import React, { FC } from 'react';
import { Row } from 'components/Grid/Grid';
import { Text } from 'components/Typography';
import { FontWeights } from 'core/CssVariables';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { RoutesPaths } from 'routes/Routes.types';
import { THeaderAlertMessageProps } from '../HeaderAlert.type';

const HeaderAlertMessage: FC<THeaderAlertMessageProps> = ({
  message,
  boldMessage,
  hasGoPaymentLink,
}) => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  // "Go to Billing" link is hidden only when the user is already on the
  // Billing tab of the Profile page, not just on the Profile page itself.
  const isInBillingPage =
    pathname === `/app/${RoutesPaths.Profile}` &&
    searchParams.get('tab') === 'billing';
  const navigate = useNavigate();
  const onNavigateBillingPage = () => {
    return navigate(`/app/${RoutesPaths.Profile}?tab=billing`, {
      replace: true,
    });
  };
  return (
    <Row role="row">
      {boldMessage && (
        <Text className="mr-1" fontlevel={5} fontWeight={FontWeights.SemiBold}>
          {boldMessage}
        </Text>
      )}
      {message && (
        <Text fontlevel={5} fontWeight={FontWeights.Regular}>
          {message}
        </Text>
      )}
      {hasGoPaymentLink && !isInBillingPage && (
        <Text
          className="pointer ml-1"
          onClick={onNavigateBillingPage}
          fontlevel={5}
          fontWeight={FontWeights.Regular}
          underline
        >
          Go to Billing
        </Text>
      )}
    </Row>
  );
};

export default HeaderAlertMessage;
